import { Fragment, useState, useRef } from 'react';
import HelpIcon from '@material-ui/icons/Help';
import { IconButton, Menu, MenuItem, MenuList, Popper, Paper, Grow, ClickAwayListener } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { logout } from '../../api/onboarding';
import UserCircle from '../../assets/UserCircle';
import { getFromLocalStorage, removeAllFromLocalStorage } from '../../utils/Helpers';

const Help = () => {
	const [anchorEl, setAnchorEl] = useState(null);
  const token = getFromLocalStorage("token");
  const [userStatue, setUserStatus] = useState(false);

  const [open, setOpen] = useState(false);

  const anchorRef = useRef(null);

  const handleClick = (event) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const hitLogout = () => {
  	removeAllFromLocalStorage();
  	setUserStatus(!useState);
  	logout();
  	window.location.href = '/'
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  if (true) {
  	return (
			<Fragment>
				<IconButton
	        aria-haspopup="true"
	        onClick={handleClick}
	        className="headerMenu"
	        ref={anchorRef}
	        aria-controls={open ? 'menu-list-grow' : undefined}
	      >
	        <HelpIcon />
          <span>Need Help</span>
	      </IconButton>

	      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <MenuItem><a target="_blank" style={{textDecoration: 'none', color: 'inherit'}} href="https://docs.cleartax.in/gst-pay-later-support-and-faqs/">FAQs</a></MenuItem>
                    <MenuItem><a style={{textDecoration: 'none', color: 'inherit'}} onClick={() => window.$crisp.push(['do', 'chat:open'])}>Chat With Us</a></MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>

			</Fragment>
		)
  } else {
  	return <Fragment></Fragment>
  }

	
}

export default Help;